import { Checkbox, FormControlLabel, FormHelperText } from '@mui/material';
import useHelperTextId from '@platform-ui-common/hooks/contexts/useHelperTextId.js';
import Color, { BorderColors } from '@platform-ui-common/utilities/Color.js';
import cx from 'classnames';
import React from 'react';

export interface CheckboxProps {
  ariaLabel?: string;
  border?: boolean;
  checked: boolean;
  disabled?: boolean;
  error?: string;
  label: React.ReactNode;
  onClick?: (value: boolean) => void;
  readonly?: boolean;
  required?: boolean;
  squashPadding?: boolean;
  className?: string;
}

const CheckboxComponent = ({
  ariaLabel,
  border = true,
  checked,
  disabled,
  error,
  label,
  onClick,
  readonly,
  required,
  squashPadding = false,
  className,
}: CheckboxProps): JSX.Element => {
  const onChange = (): void => {
    if (onClick && !readonly) {
      onClick(!checked);
    }
  };
  const helperTextId = useHelperTextId();
  const styleOverride = squashPadding ? { padding: '0rem', paddingLeft: '4px' } : undefined;

  return (
    <>
      <div
        className={cx(
          {
            'flex w-full border border-inputBorder': border,
            [BorderColors[Color.Warning].toString()]: error,
            'bg-lightBackground': checked && border,
          },
          className,
        )}
        key={ariaLabel}
      >
        <FormControlLabel
          onChange={onChange}
          control={
            <Checkbox
              checked={checked}
              color="primary"
              required={required}
              disabled={disabled}
              disableRipple={readonly}
              inputProps={{
                readOnly: !!readonly,
                'aria-invalid': !!error,
                'aria-errormessage': helperTextId,
              }}
              sx={styleOverride}
            />
          }
          label={label}
          aria-label={ariaLabel}
          sx={styleOverride}
        />
      </div>
      {error && (
        <FormHelperText error={true} id={helperTextId}>
          {error}
        </FormHelperText>
      )}
    </>
  );
};

export default CheckboxComponent;
